<template>
  <div class="alls">
    <!-- 轮播图区 -->
    <div class="banner" @click='clickSwiper'>
      <b-carousel
        id="carousel-1"
        v-model="slide"
        :interval="4000"
        controls
        indicators
        aria-current="false"
        background="#ababab"
        img-width="1024"
        img-height="480"
        style="text-shadow: 1px 1px 2px #333;"
        @sliding-start="onSlideStart"
        @sliding-end="onSlideEnd"
      >
        <!-- Text slides with image -->
        <b-carousel-slide  img-src="https://honeybee-cn.oss-cn-beijing.aliyuncs.com/images/banner2.jpg"></b-carousel-slide>
        <!-- Slides with custom text -->
        <b-carousel-slide img-src="https://honeybee-cn.oss-cn-beijing.aliyuncs.com/images/banner1.jpg"></b-carousel-slide>

        <!-- Slides with image only -->
        <b-carousel-slide  img-src="https://honeybee-cn.oss-cn-beijing.aliyuncs.com/images/banner3.jpg"></b-carousel-slide>

        <!-- Slides with img slot -->
        <!-- Note the classes .d-block and .img-fluid to prevent browser default image alignment -->
        <!-- 				<b-carousel-slide>
					<template #img>
						<img class="d-block img-fluid w-100" width="1024" height="480" img-src="https://honeybee-cn.oss-cn-beijing.aliyuncs.com/images/banner1.jpg" alt="image slot" />
					</template>
				</b-carousel-slide> -->
      </b-carousel>
    </div>
    <!-- 下载 -->
    <!-- <b-container fluid="sm" class="mt-5" style="text-align: center">
      <b-row align-h="center">
        <b-col cols="12" md="6" lg="3" xl="3" align-self="center">
          <div class="down-img">
            <a href="http://app.honeybee-edu.com/html/download.html" target="_blank"><img src="../images/android.png" width="200" /></a>
          </div>
        </b-col>
        <b-col align-v="center" cols="12" md="6" lg="3" xl="3" align-self="center">
          <div class="down-img">
            <a href="http://app.honeybee-edu.com/html/download.html" target="_blank"><img src="../images/ios.png" width="200" /></a>
          </div>
        </b-col>
      </b-row>
    </b-container> -->
    <!-- 介绍区-->
    <b-container fluid="sm" class="mt-5">
      <b-row align-self="center">
        <b-container class="col-12" style="text-align: center">
          <img src="https://honeybee-cn.oss-cn-beijing.aliyuncs.com/images/welcome.jpg" width="220px" />
        </b-container>
        <b-container class="col-8 mt-5 lead">嗡嗡雅思APP是集大数据、IOT、AI、5G等新兴技术深度融合的大学生在线教育APP， 服务于全国学子的语言培训、背景提升和出国留学。</b-container>
        <b-container class="col-10 mt-5" style="font-size: small">
          Buzzielts app is an online education app for college students integrating big data, IOT, AI, 5g and other emerging technologies. It serves the language training,
          background improvement and overseas study of students in China.
        </b-container>
      </b-row>
      <b-row>
        <b-container class="col-12 mt-5"><div class="division "></div></b-container>
      </b-row>
    </b-container>
    <!-- 具体课程区域 -->
    <b-container class="curriculum mt-8" fluid  style="text-align: center">
      <b-row>
        <h4>嗡嗡雅思四大课程</h4>
        <h5>Curriculum</h5>
        <b-container fluid="sm" class="mt-4 mb-4">
          <b-row>
            <b-col class=" mb-4 " md="6" lg="3" xl="3" v-for="(cardlist, index) in curriculum" :key="index" @click="gocoursedetails(index)">
              <div class="content">
                <b-img :src="cardlist.bg" fluid-grow alt="“响应图像”"></b-img>
                <div class="content-detail">
                  <p class="card-text">{{ cardlist.title }}</p>
                  <p class="card-label" :style="{ border: '0.1rem ' + cardlist.color + ' solid ', color: cardlist.color }">
                    <img :src="cardlist.icon" alt="" />
                    {{ cardlist.discountText }}
                  </p>
                  <div class="card-price">
                    <span :style="{ color: cardlist.color }">¥{{ cardlist.price }}</span>
                    <span v-if="cardlist.originalPrice">¥{{ cardlist.originalPrice }}</span>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
          <div class="more" @click="gotoDetail(1)"><img src="../images/more.png" alt="" /></div>
        </b-container>
      </b-row>
      <!-- 留学专业服务 -->
      <b-row class="mt-8 study-abroad" style="text-align: center">
        <h4>留学专业服务</h4>
        <h5>Study aboard</h5>
        <b-row class="study-abroad abroad-bg" align-h="center">
          <b-col class="abroad-card mb-4 " v-b-modal.modal-4 cols="12" md="5" lg="5" xl="5">
            <img src="https://honeybee-cn.oss-cn-beijing.aliyuncs.com/images/eg1.png" alt="" />
            <div class="abroad-text">
              <p>选校</p>
              <p>超值服务、精准定位、专业分析</p>
              <p class="abroad-price">
                <span>
                  <span style="font-size: 16px;">¥</span>
                  69
                </span>
                <span>¥ 199</span>
              </p>
              <!-- 		<p class="look-abroad"><span>查看详情 &nbsp;></span></p> -->
            </div>
          </b-col>
          <b-col class="abroad-card mb-4 " v-b-modal.modal-4 cols="12" md="5" lg="5" xl="5">
            <img src="https://honeybee-cn.oss-cn-beijing.aliyuncs.com/images/eg2.png" alt="" />
            <div class="abroad-text">
              <p>文书、网申和签证服务</p>
              <p>超值服务、精准定位、专业分析</p>
              <p class="abroad-price">
                <span>
                  <span style="font-size: 16px;">¥</span>
                  5000起
                </span>
                <span>原价¥28888</span>
              </p>
              <!-- 		<p class="look-abroad"><span>查看详情 &nbsp;></span></p> -->
            </div>
          </b-col>
        </b-row>
        <div @click="gotoDetail(2)" class="more"><img src="../images/more.png" alt="" /></div>
      </b-row>
      <!-- 四六级服务 -->
      <b-row class="mt-8 study-abroad">
        <h4>四六级特训营</h4>
        <h5>CET</h5>
        <b-row class="study-abroad abroad-bg" align-h="center">
          <b-col class="abroad-card abroad-card-pint mb-4 " cols="12" md="5" lg="5" xl="5" @click="gocoursedetails(4)">
            <img src="https://honeybee-cn.oss-cn-beijing.aliyuncs.com/images/eg8.png" alt="" />
            <div class="abroad-text">
              <p>四级暑期特训营 - 备考12月</p>
              <p>考前抢分，灵活上课</p>
              <p class="abroad-price">
                <span>
                  <span style="font-size: 16px;">¥</span>
                  69
                </span>
                <span>¥199</span>
              </p>
              <p class="look-abroad"><span>查看详情 &nbsp;></span></p>
            </div>
          </b-col>
          <b-col class="abroad-card  abroad-card-pint mb-4 " cols="12" md="5" lg="5" xl="5" @click="gocoursedetails(5)">
            <img src="https://honeybee-cn.oss-cn-beijing.aliyuncs.com/images/eg9.png" alt="" />
            <div class="abroad-text">
              <p>六级暑期特训营 - 备考21年6月</p>
              <p>考前抢分，灵活上课</p>
              <p class="abroad-price">
                <span>
                  <span style="font-size: 16px;">¥</span>
                  69
                </span>
                <span>¥199</span>
              </p>
              <p class="look-abroad"><span>查看详情 &nbsp;></span></p>
            </div>
          </b-col>
        </b-row>
        <div id="backdrop" @click="gotoDetail(3)" ref="backdrop" class="more"><img src="../images/more.png" alt="" /></div>
      </b-row>
    </b-container>
    <!-- 留学区域 -->
    <b-container class="study-abroad mt-8" align-h="center" align-v="center" fluid>
      <!-- 背景提升 -->
      <b-row class="mt-8 study-abroad " align-h="center"  style="text-align: center">
        <h4>背景提升</h4>
        <h5>Background</h5>
        <b-col class="backdrop  mb-4 " v-b-modal.modal-1 cols="12" md="3" lg="2" xl="2">
          <!-- 				<div class="backdrop-img">
						<img src="../images/welcome.png" alt="" />
						<div class="backdrop-label">嗡嗡雅思</div>
					</div>
					<div class="backdrop-content">
						<p>John George</p>
						<p>John George</p>
						<p><span></span></p>
						<p>
							群蜂教育是国内顶级语言培训、出国留学服务机构、旗下蜂为科技， 是一家将大数据、IOT、AI、5G等新兴技术深度融合的大学生在线教育服务的企业，
							是群蜂教育在线上教育领域的重要战略布局。
						</p>
					</div> -->
          <img src="https://honeybee-cn.oss-cn-beijing.aliyuncs.com/images/background-enhancement1.jpg" alt="" />
        </b-col>
        <b-col class="backdrop  mb-4 " v-b-modal.modal-2 align-v="center" cols="12" md="3" lg="2" xl="2">
          <img src="https://honeybee-cn.oss-cn-beijing.aliyuncs.com/images/background-enhancement2.jpg" alt="" />
          <!-- 					<div class="backdrop-img">
						<img src="../images/welcome.png" alt="" />
						<div class="backdrop-label">嗡嗡雅思</div>
					</div>
					<div class="backdrop-content">
						<p>John George</p>
						<p>John George</p>
						<p><span></span></p>
						<p>
							群蜂教育是国内顶级语言培训、出国留学服务机构、旗下蜂为科技， 是一家将大数据、IOT、AI、5G等新兴技术深度融合的大学生在线教育服务的企业，
							是群蜂教育在线上教育领域的重要战略布局。
						</p>
					</div> -->
        </b-col>
        <b-col class="backdrop  mb-4 " align-v="center" v-b-modal.modal-3 cols="12" md="3" lg="2" xl="2">
          <img src="https://honeybee-cn.oss-cn-beijing.aliyuncs.com/images/background-enhancement3.jpg" alt="" />
          <!-- 					<div class="backdrop-img">
						<img src="../images/welcome.png" alt="" />
						<div class="backdrop-label">嗡嗡雅思</div>
					</div>
					<div class="backdrop-content">
						<p>John George</p>
						<p>John George</p>
						<p><span></span></p>
						<p>
							群蜂教育是国内顶级语言培训、出国留学服务机构、旗下蜂为科技， 是一家将大数据、IOT、AI、5G等新兴技术深度融合的大学生在线教育服务的企业，
							是群蜂教育在线上教育领域的重要战略布局。
						</p>
					</div> -->
        </b-col>
      </b-row>
      <!-- 老师微信-->
      <div class="teachers-wechat"  style="text-align: center"><span>国内外一流科研、实习项目，大牛带队，sci、natural发到手软~</span></div>
      <div class="teachers-wechatimg"  style="text-align: center">
        <img class="pointer" src="../images/adviserwechat.png" alt="" />
        扫码添加老师微信
        <br id="about" ref="about" />
        获取项目详情
      </div>
      <!-- 背景提升 -->
      <b-row class="mt-8 study-abroad" align-h="center"  style="text-align: center">
        <h4>关于我们</h4>
        <h5>About us</h5>
        <b-row align-h="center">
          <b-col class="code  mb-4 " cols="12" md="3" lg="2" xl="2">
            <img class="pointer" src="../images/official.jpg" alt="" />
            <div>
              <img src="../images/wechaticon.png" alt="" />
              官方微信
            </div>
          </b-col>
          <b-col class="code  mb-4 " cols="12" md="3" lg="2" xl="2">
            <img class="pointer" src="../images/tiktok.png" alt="" />

            <b-modal id="modal-1" size="lg" hide-footer>
              <img width="80%" style="margin: auto;display: block;" src="https://honeybee-cn.oss-cn-beijing.aliyuncs.com/images/background-enhancement1.jpg" />
            </b-modal>
            <b-modal id="modal-2" size="lg" hide-footer>
              <img width="80%" style="margin: auto;display: block;" src="https://honeybee-cn.oss-cn-beijing.aliyuncs.com/images/background-enhancement2.jpg" />
            </b-modal>
            <b-modal id="modal-3" size="lg" hide-footer>
              <img width="80%" style="margin: auto;display: block;" src="https://honeybee-cn.oss-cn-beijing.aliyuncs.com/images/background-enhancement3.jpg" />
            </b-modal>
            <b-modal id="modal-4" centered size="sm" hide-footer title="添加老师微信">
              <img width="80%" style="margin: auto;display: block;" src="../images/adviserwechat.png" />
            </b-modal>
            <div style="clear: both;">抖音</div>
          </b-col>
          <b-col class="code  mb-4 " cols="12" md="3" lg="2" xl="2">
            <img class="pointer" src="../images/wechat-videonumber.jpg" alt="" />
            <div>微信视频号</div>
          </b-col>
        </b-row>
      </b-row>
    </b-container>
  </div>
</template>
<script>
/* 	import rem from "@/public/rem.js"; */
export default {
  name: 'HelloWorld',
  data () {
    return {
      slide: 0,
      sliding: null,
      curriculum: [
        {
          bg: 'https://honeybee-cn.oss-cn-beijing.aliyuncs.com/images/curriculum-bg1.png',
          title: '雅思督学体验课',
          icon: 'https://honeybee-cn.oss-cn-beijing.aliyuncs.com/images/curriculum-icon1.png',
          discountText: '购买即日起督学任务开始生效',
          color: '#F5A100',
          price: 69,
          originalPrice: 825.00
        },
        {
          bg: 'https://honeybee-cn.oss-cn-beijing.aliyuncs.com/images/curriculum-bg2.png',
          title: '雅思1对1每日微课',
          icon: 'https://honeybee-cn.oss-cn-beijing.aliyuncs.com/images/curriculum-icon2.png',
          discountText: '限时用劵立减，赠送雅思大礼包',
          color: '#A18CD1',
          price: '2200-9100',
          originalPrice: ''
        },
        {
          bg: 'https://honeybee-cn.oss-cn-beijing.aliyuncs.com/images/curriculum-bg3.png',
          title: '雅思精品特训班',
          icon: 'https://honeybee-cn.oss-cn-beijing.aliyuncs.com/images/curriculum-icon3.png',
          discountText: '限时用劵立减，赠送雅思大礼包',
          color: '#159757',
          price: 8888,
          originalPrice: 12800
        },
        {
          bg: 'https://honeybee-cn.oss-cn-beijing.aliyuncs.com/images/curriculum-bg4.png',
          title: '雅思1对1提分宝',
          icon: 'https://honeybee-cn.oss-cn-beijing.aliyuncs.com/images/curriculum-icon4.png',
          discountText: '限时用劵立减，赠送雅思大礼包',
          color: '#3DACFF',
          price: 19900,
          originalPrice: 28800
        }
      ]
    }
  },
  methods: {
    clickSwiper (e) {
      window.open('https://mp.weixin.qq.com/s/q2IPvR3jEwulE94FPSQpTQ')
    },
    gotoDetail (_index) {
      if (_index == 1) {
        this.$router.push('/ielts/ielts')
      } else if (_index == 2) {
        this.$router.push('/studyabroad/studyabroad')
      } else if (_index == 3) {
        this.$router.push('/cet/cet')
      }
    },
    onSlideStart (slide) {
      this.sliding = true
    },
    onSlideEnd (slide) {
      this.sliding = false
    },
    gocoursedetails (type) {
      console.log('type:',type)
      // 课程详情
      /* console.log(navigator.userAgent); */
      let os = (function () {
        let ua = navigator.userAgent,
          isWindowsPhone = /(?:Windows Phone)/.test(ua),
          isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
          isAndroid = /(?:Android)/.test(ua),
          isFireFox = /(?:Firefox)/.test(ua),
          isChrome = /(?:Chrome|CriOS)/.test(ua),
          isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
          isPhone = /(?:iPhone)/.test(ua) && !isTablet,
          isPc = !isPhone && !isAndroid && !isSymbian
        return {
          isTablet: isTablet,
          isPhone: isPhone,
          isAndroid: isAndroid,
          isPc: isPc
        }
      })()
      /*
			if(os.isAndroid || os.isPhone) { //手机
			  window.location.href="https://app.honeybee-edu.com/h5/pages/contens/index/index?typesting=69";
			} else if(os.isTablet) { //ipad
			  window.location.href="https://app.honeybee-edu.com/h5/pages/contens/index/index?typesting=69";
			} else */
      if (os.isPc) {
        // pc端
        this.$store.commit('change', type)
        sessionStorage.setItem('type', type)
        //	console.log(sessionStorage.getItem('type'));
        this.$router.push('/coursedetails/coursedetails')
      } else {
        if (type == 0) {
          window.location.href = 'https://app.honeybee-edu.com/h5/pages/contens/index/index?typesting=69'
        } else if (type == 1) {
          window.location.href = 'https://app.honeybee-edu.com/h5/pages/contens/index/index?typesting=ielts_mini_course'
        } else if (type == 2) {
          window.location.href = 'https://app.honeybee-edu.com/h5/pages/contens/index/index?typesting=ielts_class_course'
        } else if (type == 3) {
          window.location.href = 'https://app.honeybee-edu.com/h5/pages/contens/index/index?typesting=ielts_1v1_course'
        } else if (type == 4) {
          window.location.href = 'https://youke.honeybee-edu.com/h5'
        } else if (type == 5) {
          window.location.href = 'https://youke.honeybee-edu.com/h5'
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.alls {
  width: 100%;
  overflow: hidden;
}
h4,
h5,
h6,
h3 {
  width: 100%;
}
h4 {
  font-weight: bold !important;
}
.mt-6 {
  margin-top: 4rem !important ;
}

.mt-8 {
  margin-top: 6rem !important ;
}
.mt-10 {
  margin-top: 8rem !important ;
}
.down-img img {
  width: 12rem;
  height: 3.5rem;
  margin-top: 1rem;
}
.down-code img {
  width: 6rem;
  height: 6rem;
  margin-top: 1rem;
}
.division {
  width: 10rem;
  height: 0.5rem;
  background: #fcc625;
  border-radius: 4px;
  margin: auto;
}
.curriculum {
  background-image: url(../images/center-bg.png);
  background-repeat: no-repeat;
  background-size: 100% 93%;
}
h5 {
  color: #c9caca;
}
.content:hover {
  -webkit-box-shadow: 0px 0px 5px 1px #fcc625; /*老的For Chrome5+, Safari5+*/
  -moz-box-shadow: 0px 0px 5px 1px #fcc625; /* 老的 firefox */
  box-shadow: 0px 0px 5px 1px #fcc625;
  cursor: pointer;
  margin-top: -0.625rem;
}
.content {
  width: 99%;
  margin: auto;
  text-align: left;
  background-repeat: no-repeat;
  background-color: #ffffff;
  -webkit-box-shadow: 0px 0px 5px 1px #efefee; /*老的For Chrome5+, Safari5+*/
  -moz-box-shadow: 0px 0px 5px 1px #efefee; /* 老的 firefox */
  box-shadow: 0px 0px 5px 1px #efefee;
}
.content-detail {
  padding: 0 1rem 1rem 1rem;
}
.content-img {
  width: 100%;
}
.card-text {
  font-weight: bold;
  font-size: 1.3rem;
}
.card-label {
  font-size: 0.5rem;
  color: #f5a100;
  border: 0.1rem solid #f5a100;
  border-radius: 0.4rem;
  display: inline-block;
  padding: 0.2rem 0.8rem 0.2rem 0.4rem;
  font-weight: 500;
}
.card-label img {
  padding-right: 0.24rem;
  padding-bottom: 0.2rem;
}
.card-price span:nth-child(1) {
  color: #f5a100;
  font-weight: bold;
  font-size: 1.3rem;
  margin-right: 0.5rem;
}
.card-price span:nth-child(2) {
  color: #c6c6c6;
  font-size: 0.8rem;
  text-decoration: line-through;
}
.more {
  width: 8rem;
  height: 2rem;
  margin: 1.5rem auto;
  cursor: pointer;
}
.more:hover {
  -webkit-box-shadow: 0px 0px 5px 1px #fcc625; /*老的For Chrome5+, Safari5+*/
  -moz-box-shadow: 0px 0px 5px 1px #fcc625; /* 老的 firefox */
  box-shadow: 0px 0px 5px 1px #fcc625;
}
.more img {
  width: 100%;
  height: 100%;
}

.abroad-bg {
  width: 100%;
  /* 	background-image: url(../images/central.png); */
  background-size: 100% 15.3125rem;
  background-repeat: no-repeat;
  margin: 0 !important;
  margin-top: 2.5rem !important;
}
.abroad-card-pint {
  cursor: pointer;
}
.abroad-card-pint:hover {
  color: #f5a100 !important;
}
.abroad-card-pint:hover .look-abroad {
  color: #f5a100 !important;
}
.abroad-card img {
  width: 100%;

  /* 	height: 15.3125rem; */
}
/* .abroad-text{

	color: #f5a100;
} */
.abroad-text p:nth-child(1) {
  font-size: 1.55rem;
  font-weight: bold;
  margin-top: 1.5rem;
}
.abroad-text p:nth-child(2) {
  font-size: 0.9625rem;
  font-weight: bold;
}
.abroad-price span:nth-child(1) {
  font-size: 1.5625rem;
  font-weight: bold;
  color: #f5a100;
}
.abroad-price span:nth-child(2) {
  color: #c6c6c6;
  font-size: 0.8rem;
  font-weight: bold;
  margin-left: 0.8125rem;
  text-decoration: line-through;
}
.look-abroad {
  font-size: 1rem;
  font-weight: 400;
  color: #727171;
  cursor: pointer;
}
.backdrop:hover {
  margin-top: 0;
  cursor: pointer;
  -webkit-box-shadow: 0px 4px 12px 6px #fcc625; /*老的For Chrome5+, Safari5+*/
  -moz-box-shadow: 0px 4px 12px 6px #fcc625; /* 老的 firefox */
  box-shadow: 0px 4px 12px 6px #fcc625;
}
.backdrop {
  width: 100%;
  margin: 0.625rem;
  padding: 0 !important;
  -webkit-box-shadow: 0px 4px 12px 6px #efefee; /*老的For Chrome5+, Safari5+*/
  -moz-box-shadow: 0px 4px 12px 6px #efefee; /* 老的 firefox */
  box-shadow: 0px 4px 12px 6px #efefee;
}
.backdrop img {
  width: 100%;
}
.backdrop-img {
  position: relative;
}
.backdrop-label {
  position: absolute;
  bottom: 1.5625rem;
  right: 0;
  font-size: 0.875rem;
  font-weight: 400;
  color: #ffffff;
  background: #f2c52d;
  padding: 0.3rem 1rem;
}
.backdrop-content {
  padding: 1.25rem 1.6rem;
  text-align: left;
}
.backdrop-content p {
  padding: 0;
  margin: 0;
}
.backdrop-content p:nth-child(1) {
  font-weight: bold;
  color: #000000;
  font-size: 1.125rem;
}
.backdrop-content p:nth-child(2) {
  color: #333333;
  font-size: 0.8125rem;
}
.backdrop-content p:nth-child(3) span {
  display: block;
  width: 1.875rem;
  height: 0.0625rem;
  margin: 0.9375rem 0;
  border-bottom: 1px solid #282c35;
}
.backdrop-content p:nth-child(4) {
  color: #485157;
  font-size: 0.75rem;
}
.teachers-wechat {
  margin-top: 1.875rem;
}
.teachers-wechat span {
  font-size: 1.0625rem;
  font-weight: bold;
  color: #000000;
  border-bottom: 2px solid #6a6a6a;
  padding-bottom: 0.5375rem;
  line-height: 2.3rem;
}
.teachers-wechatimg {
  color: #000000;
  font-size: 0.8125rem;
}
.teachers-wechatimg img {
  width: 10.125rem;
  height: 10.125rem;
  display: block;
  margin: 1.875rem auto 0 auto;
}
.pointer:hover {
  //cursor:pointer;
}
.code img {
  width: 70%;
}
.code div {
  margin-top: 1.25rem;
}
.code div img {
  width: 1.25rem;
  height: 1.25rem;
}
@media (min-width: 576px) {
  .content {
    background-size: 100% 100%;
  }
}

@media (min-width: 768px) {
  .content {
    background-size: 100% 100%;
  }
  .abroad-bg {
    // background-image: url(../images/central.png);
    background-size: 100% 28.3125rem;
  }
  .abroad-card img {
    height: 28.3125rem;
  }
}

@media (min-width: 1200px) {
  .abroad-bg {
    background-size: 100% 28.3125rem;
    background-image: url(../images/central.png);
  }

  .abroad-card img {
    height: 28.3125rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue